import { Message } from '@dinosband/bv-messenger-schema'
import { MessagesChunkSize } from '..'


export function cachedMessage (contents: Message[], seq: number) {
  return contents.find((i) => i.seq === seq) as unknown as CachedMessage | undefined
}

export interface CachedMessage extends Message {
  _cid?: number // index in message-chunk
}

export function cidRange (direction: 'before' | 'after' | 'around', cid: number, size: number = MessagesChunkSize) {
  if (direction == 'before') {
    return _prevRange(cid, size)
  } else if (direction == 'after') {
    return _nextRange(cid, size)
  } else {
    return _aroundRange(cid, size)
  }
}

function _nextRange (index: number, size: number) {
  const min = index
  const max = index + size - 1
  return [min, max]
}

function _prevRange (index: number, size: number) {
  const min = index - size + 1
  const max = index
  return [min, max]
}

function _aroundRange (index: number, size: number) {
  const min = index - Math.floor(size / 2)
  const max = index + Math.floor(size / 2)
  return [min, max]
}
